import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

export interface ProductMaterialFilters {
    search?: string;
    commodityGroup?: string;
    productGroup?: string;
}

export default class ProductMaterialAPI {
    public static async getAll(page: number = 1, pageSize: number = 10, filters?: ProductMaterialFilters) {
        let ProductMaterial;

        try {
            ProductMaterial = (await ApiController.get(
                ApiRoutes.productVersion.materials(page, pageSize, filters),
            )) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(ProductMaterial);
    }
}
